<template>
    <div style="padding:10px;">
        <!-- <div>
            <div style="margin-bottom:4px;font-size:12px;">
                <h1 style="margin-right:6px;font-size:18px; font-weight:500; margin-bottom:10px;">商品</h1>
                <el-button size="mini" icon="el-icon-refresh" @click="transferProduct" type="primary">重新传输商品</el-button>
            </div>
            <hr style='background-color:#409eff; height:1px; border:none;'>
            <div style="height:10px;"></div>
        </div> -->
        <!-- <div>
            <div style="margin-bottom:4px;font-size:12px;">
                <h1 style="margin-right:6px;font-size:18px; font-weight:500; margin-bottom:10px;">供应商</h1>
                <el-button size="mini" icon="el-icon-refresh" @click="transferSupplier" type="primary">重新传输供应商</el-button>
            </div>
            <hr style='background-color:#409eff; height:1px; border:none;'>
            <div style="height:10px;"></div>
        </div>

        <div>
            <div style="margin-bottom:4px;font-size:12px;">
                <h1 style="margin-right:6px;font-size:18px; font-weight:500; margin-bottom:10px;">客户</h1>
                <el-button size="mini" icon="el-icon-refresh" @click="transferBuyer" type="primary">重新传输客户</el-button>
            </div>
            <hr style='background-color:#409eff; height:1px; border:none;'>
            <div style="height:10px;"></div>
        </div> -->
        <div>
            <div style="margin-bottom:4px;font-size:12px;">
                <h1 style="margin-right:6px;font-size:18px; font-weight:500; margin-bottom:10px;">WMS</h1>
                <el-button size="mini" icon="el-icon-refresh" @click="transferWMS" type="primary">根据参数重传WMS</el-button>
            </div>
            <hr style='background-color:#409eff; height:1px; border:none;'>
            <div style="height:10px;"></div>
        </div>
        <el-dialog :title="title" :visible.sync="dialogVisible" width="30%">

        </el-dialog>
    </div>
</template>

<script>
export default {
    name: 'initDataGl',
    components: {},
    data() {
        return {
            requesUrl: '',
            dialogVisible: false,
            title: "",
        };
    },
    watch: {},
    computed: {},
    methods: {
        async transferProduct() {
            const responseData = await this.$http.retryGoods()
            console.log(responseData);
            if (responseData.status == 200) {
                this.$message.success("传输成功")
            } else {
                this.$message.error("传输失败")
            }
        },
        async transferSupplier() {
            const responseData = await this.$http.retrySup()
            if (responseData.status == 200) {
                this.$message.success("传输成功")
            } else {
                this.$message.error("传输失败")
            }
        },
        async transferBuyer() {
            const responseData = await this.$http.retryCus()
            if (responseData.status == 200) {
                this.$message.success("传输成功")
            } else {
                this.$message.error("传输失败")
            }
        },
        transferWMS() {
            this.$prompt('请输入参数', '传输WMS', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
            }).then(({ value }) => {
                this.wmsClick(value)
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '取消传输'
                });
            });
        },
        async wmsClick(val) {
            const responseData = await this.$http.retryParam({
                ids: [val]
            })
            if (responseData.status == 200) {
                this.$message.success("传输成功")
            } else {
                this.$message.error("传输失败")
            }
        },
    },
    created() {
        this.requesUrl = this.$store.getters.getConfig.requestUrl;
    },
    mounted() { }
};
</script>
<style  scoped></style>s